import { FleekError } from './FleekError';

type UserSecretKeyAlreadyExistsErrorOptions = Record<string, never>;

export class UserSecretKeyAlreadyExistsError extends FleekError<UserSecretKeyAlreadyExistsErrorOptions> {
  public name = 'UserSecretKeyAlreadyExistsError';

  toString = () => 'A secret key for this user already exists.';
}
